import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme as defaultTheme } from './mineko.theme';
export const BasicTheme = ({ children, theme }) => {
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsxs(ThemeProvider, { theme: theme || defaultTheme, children: [_jsx(CssBaseline, {}), " ", children] }) }));
};
